import React from 'react';

const Loading = () => {
    return (
        <section className='min-h-screen flex justify-center items-center'>
            <button className="btn btn-square loading"></button>
        </section>
    );
};

export default Loading;